import { FC, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { Container, Stack, Typography } from '@mui/material';

import { useRouter } from '@cvt/routing';
import { useDictionary } from '@cvt/hooks/useDictionary';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { BoxWell } from '@shared/components/BoxWell';

import { PreferenceVersionHistory } from '@modules/Users/partials/PreferenceVersionHistory';

import { ObjectiveVersionTabs } from '../partials/ObjectiveVersionTabs';
import { CurrentObjectives } from '../partials/CurrentObjectives';


export const Objectives: FC = () => {
  const router = useRouter();
  const dictionary = useDictionary();

  return (
    <Container maxWidth="md" sx={{ mt: 2 }} disableGutters>
      <BoxWell sx={{ px: 3, py: 4 }}>
        <Stack gap={4}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack spacing={2}>
              <Typography variant="h4" component="h1" fontWeight={600} fontSize={{ xs: 24, sm: 30 }}>
                {dictionary.objectives.title}
              </Typography>
              <Typography variant="body1" fontSize={16} color="text.secondary" fontWeight={500}>
                {dictionary.objectives.subtitle}
              </Typography>
            </Stack>
          </Stack>

          <ObjectiveVersionTabs/>

          <ErrorBoundary>
            <Suspense fallback={<BodyLoading height="100%"/>}>
              <Routes>
                <Route
                  path="/current"
                  element={<CurrentObjectives/>}
                />
                <Route
                  path="/history"
                  element={
                    <ErrorBoundary message={dictionary.preferences.versionSummary.emptyHistory}>
                      <PreferenceVersionHistory description={dictionary.objectives.versionHistoryDescription}/>
                    </ErrorBoundary>
                  }
                />
                <Route path="*" element={<Navigate to={router.objectives.current.path} replace/>}/>
              </Routes>
            </Suspense>
          </ErrorBoundary>

        </Stack>
      </BoxWell>
    </Container>
  );
};
